import { Component, OnInit } from '@angular/core';
import { BBSelfGuidedInvite, BBSelfGuidedInviteDefaultValues } from 'src/app/components/invitations/bb-invitations/bb-invitation';
import { ApplicationLanguages } from 'src/app/components/language/language';
import { BbInvitationService } from 'src/app/services/bb-invitation.service';
import { LanguageService } from 'src/app/services/language.service';
import { ProvinceService } from 'src/app/services/province.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-bb-self-guided-registration-first-step',
    templateUrl: './bb-self-guided-registration-first-step.component.html',
    styleUrls: ['./bb-self-guided-registration-first-step.component.scss'],
    standalone: false
})
export class BbSelfGuidedRegistrationFirstStepComponent implements OnInit {

  provinces:any[]=[]
  isSubmitted=false
  hideEmailSentSpan=true;
  BBsgpinvitation:BBSelfGuidedInvite=BBSelfGuidedInviteDefaultValues()
  isInputValid:{email: boolean, province: boolean} = {email: false, province: false};
  translations: Record<string, string> = {};

  constructor(
    private provinceservice:ProvinceService,
    private bbinviteservice:BbInvitationService,
    private languageService: LanguageService,
    private translationService: TranslationService) { }

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });
    this.provinceservice.getProvincesForRegistration().subscribe({
      next:(data)=>{
        this.provinces=data
      }
    });
  }
isValidEmail(email: string): boolean {
  console.log(email, /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
  validateRequiredFields():boolean
  {
    this.isInputValid.email = true;
    this.isInputValid.province = true;

    if(this.BBsgpinvitation.email == null || this.BBsgpinvitation.email == '' || !this.isValidEmail(this.BBsgpinvitation.email))
      this.isInputValid.email = false;
    if(this.BBsgpinvitation.provinceId == null || this.BBsgpinvitation.provinceId == 0)
      this.isInputValid.province = false;

    return this.isInputValid.email && this.isInputValid.province;
  }

  register() {
    this.isSubmitted=true;
    if(!this.validateRequiredFields())
    {
      return;
    }

    // Language comes from the host (autonome / French domain → FR), not a form dropdown.
    this.BBsgpinvitation.languageId = this.languageService.isFrenchHost()
      ? ApplicationLanguages.FRENCH
      : ApplicationLanguages.ENGLISH;

    this.bbinviteservice.createbbselfguidedinvitation(this.BBsgpinvitation).subscribe({
      next:(data)=>{
          console.log(data);
          this.hideEmailSentSpan=false
      }
    })
    }
}
